import { render, staticRenderFns } from "./pinggu-report.vue?vue&type=template&id=120c5c22&scoped=true&"
import script from "./pinggu-report.vue?vue&type=script&lang=ts&"
export * from "./pinggu-report.vue?vue&type=script&lang=ts&"
import style0 from "./pinggu-report.vue?vue&type=style&index=0&id=120c5c22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120c5c22",
  null
  
)

export default component.exports